export default "__VITE_ASSET__CDIuz6Cp__"